"use client";

import { useEffect } from 'react';

export default function ServiceWorkerRegistration() {
  useEffect(() => {
    // Only register service worker in production or if explicitly enabled in development
    if (
      typeof window !== 'undefined' &&
      'serviceWorker' in navigator &&
      (window.location.hostname !== 'localhost' || process.env.NEXT_PUBLIC_ENABLE_SW_DEV === 'true')
    ) {
      const registerServiceWorker = async () => {
        try {
          const registration = await navigator.serviceWorker.register('/sw.js');
          
          console.log('Service Worker registered successfully:', registration.scope);
          
          // Handle updates when a new service worker is available
          registration.addEventListener('updatefound', () => {
            const newWorker = registration.installing;
            
            if (newWorker) {
              newWorker.addEventListener('statechange', () => {
                if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                  // New service worker is installed and ready to take over
                  console.log('New service worker installed, reload to activate');
                  
                  // Show update notification to user
                  if (window.confirm('New version available! Reload to update?')) {
                    window.location.reload();
                  }
                }
              });
            }
          });
          
          // Check for updates periodically (every hour)
          setInterval(() => {
            registration.update()
              .catch(err => console.error('Error checking for SW updates:', err));
          }, 60 * 60 * 1000);
          
        } catch (error) {
          console.error('Service Worker registration failed:', error);
        }
      };
      
      // Register service worker when the component mounts
      registerServiceWorker();
      
      // Listen for page visibility changes to refresh service worker when user returns
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') {
          navigator.serviceWorker.getRegistration()
            .then(registration => registration?.update())
            .catch(err => console.error('Error updating service worker:', err));
        }
      });
    }
  }, []);

  return null;
}